/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs */

const es_components_payment_choice_modal_pay_advance_badge = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 20% de descuento`)
};

const en_components_payment_choice_modal_pay_advance_badge = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 20% off`)
};

/**
* | output |
* | --- |
* | "Up to 20% off" |
*
* @param {Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_advance_badge = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Advance_BadgeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_advance_badge(inputs)
	return en_components_payment_choice_modal_pay_advance_badge(inputs)
});
export { components_payment_choice_modal_pay_advance_badge as "components.payment_choice_modal.pay_advance_badge" }